module.exports = __webpack_public_path__ + "img/sankaku_81_red.9c4e8938.png";